<!-- 搜车用品 -->
<template>
  <div class="business-content-main goodSearch" id="goodSearch">
    <div class="scroll-view">
    <div class="head">
      <div class="bread-nav">
        <breadcrumb></breadcrumb>
      </div>
      <div class="search-ctn">
        <div class="search-ctn-left">
          <div class="search-name">商品编码</div>
          <el-input
            style="width: 200px"
            class="search-item"
            size="small"
            v-model="searchData.GoodsCode"
            placeholder="请输入商品编码"
          ></el-input>
          <div class="search-name">商品名称</div>
          <el-input
            class="search-item"
            size="small"
            v-model="searchData.Keyword"
            placeholder="请输入商品名称"
          ></el-input>
          <div class="search-name">适用车型</div>
          <el-input
            class="search-item"
            size="small"
            v-model="searchData.SeriesId"
            placeholder="请输入车型或车品牌"
          ></el-input>
          <div class="search-name">商品类型</div>
          <div class="search-item goods-categories">
            <el-input
              readonly
              size="small"
              v-model="goodsType"
              @click.stop.native="showCategories()"
              placeholder="请选择用品类别"
            ></el-input>
            <div class="categories-tree" v-show="categoriesShow">
              <chooseGoodsType from="supplieSearch" @chooseNode="chooseNode"></chooseGoodsType>
            </div>
          </div>
          <el-button
            size="small"
            icon="el-icon-search"
            class="search-btn btn-primary"
            @click="handleSearch"
          >查询</el-button>
          <el-button
            size="small"
            icon="el-icon-refresh"
            class="search-btn btn-primary"
            @click="resetSearch"
          >重置</el-button>
        </div>
      </div>
    </div>
    <div class="qp-ctn" v-if="tableDataLength != 0">
      <el-card class="box-card qp-item" v-for="item in tableData" :key="item.Id">
        <div @click="gotoDetails(item.Id)">
          <div class="qp-cover">
            <img
              :src="downloadUrl+(item.ShowImg.length>0?item.ShowImg+ '?imageView2/2/w/218':'/UploadFile/Commons/Public/Images/200x200.png')"
              alt
              :onerror="defaultImg"
            />
            <div
              class="goods-activity"
              v-if="item.IsNew == 1 || item.IsBest == 1 ||item.IsHot == 1"
            >
              <div>
                <div class="type-icon" v-if="item.IsNew == 1">新品</div>
                <div class="type-icon" v-if="item.IsBest == 1">精品</div>
                <div class="type-icon" v-if="item.IsHot == 1">热门</div>
              </div>
            </div>
          </div>
          <div class="qp-msg">
            <div class="qp-dir">
              <p>
                <span class="goods-money">￥{{item.ShopPrice}}</span>
              </p>
              <!--                            <p>库存:{{item.InventoryQuantity}}</p>-->
            </div>
            <p class="qp-name" :title="item.Name">{{item.Name}}</p>
            <p
              :title="item.GoodsCode"
            >编码:{{item.GoodsCode.length>20?item.GoodsCode.substring(0,17)+'...':item.GoodsCode}}</p>
            <!--                        <p class="ops-ctn" v-if="item.InventoryQuantity > 0">-->

            <p class="ops-ctn">
              <el-button
                size="mini"
                @click.stop="addToCar(item.Id)"
                v-if="permission.addCar"
              >{{permission.addCar}}</el-button>
              <el-button
                size="mini"
                @click.stop="gotoOrderInfo(item.Id)"
                v-if="permission.buy"
              >{{permission.buy}}</el-button>
            </p>
            <!--                        <p v-else class="no-inventory">-->
            <!--                            暂无库存-->
            <!--                        </p>-->
          </div>
        </div>
      </el-card>
    </div>
    <div v-else class="no-data">暂无对应的搜索结果</div>
    <el-backtop target=".scroll-view" :bottom="100" :visibility-height="250"></el-backtop>
    <toolbar ref="toolbar"></toolbar>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import chooseGoodsType from "@/components/common/chooseShopGoodsType.vue";
import toolbar from "@/components/common/toolbar.vue";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "goodSearch",
  components: {
    chooseGoodsType,
    toolbar,
    breadcrumb
  },
  data() {
    return {
      goodsType: "",
      categoriesShow: false,
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
      downloadUrl: this.$util.QN_URL_BASE,
      tableData: [],
      tableDataLength: 0,
      noMore: false,
      options: [],
      searchData: {
        GoodsCode: "",
        Keyword: "",
        CategoryId: "",
        SeriesId: "",
        page: 1,
        limit: 12
      },
      balls: [
        //小球 设为3个
        {
          show: false
        },
        {
          show: false
        },
        {
          show: false
        },
        {
          show: false
        },
        {
          show: false
        }
      ],
      dropBalls: [],
      permission: {}
    };
  },
  beforeRouteLeave(to, from, next) {
    let scrollElement = document.querySelector(".business-content");
    scrollElement.removeEventListener("scroll", this.handleScroll, true);
    next();
  },
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     //因为当钩子执行前，组件实例还没被创建
  //     // vm 就是当前组件的实例相当于上面的 this，所以在 next 方法里你就可以把 vm 当 this 来用了。
  //     let scrollElement = document.querySelector(".business-content");
  //     scrollElement.addEventListener("scroll", vm.handleScroll, true);
  //     vm.calculateLimit();
  //   });
  // },
  mounted() {
    let fullPath = this.$route.fullPath;
    document.onkeydown = event => {
      let isDialog =document.querySelector(".v-modal");
      let layui=document.querySelectorAll(".layui-layer");
      if(fullPath == this.$route.fullPath&&!isDialog&&layui.length<=1){ 
          if (event && event.keyCode == 13) {
            this.handleSearch();
          }
        }
    };
    window.onclick = () => {
      this.categoriesShow = false;
    };
    // this.getTableData();
    this.permission = this.$util.getPermission("SupplieSearch");
    let scrollElement = document.querySelector(".business-content");
    scrollElement.addEventListener("scroll", this.handleScroll, true);
    this.calculateLimit();
  },
  methods: {
    //计算每页获取数据的最大值并且查询数据
    calculateLimit() {
      // let clientHeight = document.querySelector("#business").clientHeight;
      let maxWidth = document.querySelector(".scroll-view")
        .clientWidth;
      // let flowRow = Math.floor(clientHeight / 390); //每一页的行数
      let flowRow =2;
      let flowColumn = Math.floor(maxWidth / 220); //每一页的列数
      this.searchData.limit = flowColumn * flowRow; //当前界面能容纳的item数

      this.getTableData();
    },
    handleScroll() {
      //没有数据，有弹窗打开时return
      if (this.tableData.length == 0) return;
      let scrollTop = document.querySelector(".scroll-view").scrollTop; //滚动条顶部的位置
      let scrollHeight = document.querySelector(".scroll-view")
        .scrollHeight; //滚动条高度
      let windowHeight = document.querySelector(".scroll-view")
        .clientHeight; //可视区的高度
      if (scrollTop + windowHeight>= scrollHeight) {
        if (!this.noMore) {
          this.searchData.page += 1;
          this.getTableData();
        } else {
          this.$util.warningMsg("没有更多数据了");
        }
      }
    },
    // 添加到购物车
    addToCar(GoodId) {
      this.$util.goodsJoinCar(GoodId).then(() => {
        this.$refs.toolbar.getTableData();
      });
    },
    // 重置表单
    resetSearch() {
      this.goodsType = "";
      this.searchData.Keyword = "";
      this.searchData.GoodsCode = "";
      this.searchData.CategoryId = "";
      this.searchData.SeriesId = "";
      this.searchData.page = 1;
    },
    // 选中商品分类
    chooseNode(data) {
      if (data) {
        this.goodsType = data.Category.CategoryName;
        this.searchData.CategoryId = data.Category.CategoryNumber;
      } else {
        this.goodsType = "";
        this.searchData.CategoryId = "";
      }
      this.categoriesShow = false;
    },
    // 显示树
    showCategories() {
      this.categoriesShow = true;
    },
    // 跳转结算页
    gotoOrderInfo(id) {
      this.$router.push(
        `/shop/getOrderInfo?GoodsId=${id}&GoodsType=5&GoodsTypeId=${id}`
      );
    },
    // 跳转到汽配详情
    gotoDetails(id) {
      this.$router.push(`./goodsDetail?id=${id}&from=SupplieSearch`);
    },
    // 获取数据
    getTableData() {
      this.$util
        .axiosGet({
          url: "/search/Search/MallVehicleAndPartsSearch", //搜索商城车用品与汽配件列表,by qdl 2020/5/12
          data: this.searchData,
          search: true
        })
        .then(res => {
          if (res.data) {
            this.tableData = this.tableData.concat(res.data);
            this.tableDataLength = res.count;
            this.noMore = this.tableData.length == this.tableDataLength;
          }
        });
    },
    handleSearch() {
      this.searchData.page = 1;
      this.tableData = [];
      document.querySelector(".scroll-view").scrollTop = 0; //滚动条移回顶部
      this.getTableData();
    }
  }
};
</script>
<style lang="less" scoped>
.goods-money {
  color: red;
  font-size: @font-md;
}
.no-inventory {
  color: red;
  line-height: 24px;
  padding: 10px 0;
}
.ball {
  position: fixed;
  left: 32px;
  bottom: 22px;
  z-index: 200;
  transition: all 0.4s cubic-bezier(0.49, -0.29, 0.75, 0.41);
  /*贝塞尔曲线*/
}
.inner {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: rgb(0, 160, 220);
  transition: all 0.4s linear;
}

.business-content-main {
  height: 100%;
  overflow: hidden;
}
.scroll-view {
  height: 99%;
  overflow-y: scroll;
}
.head {
  position: fixed;
  top: 99px;
  padding: 10px 10px 10px 10px;
  height: 110px;
  // width: 100%;
  width: 90%;
  background-color: white;
  z-index: 1;
  margin-left: -20px;
}
.goodSearch {
  padding-right: 15px;
}
.goods-categories {
  position: relative;
}
.qp-ctn {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 100px;
  align-content: flex-start;
}
.qp-item {
  cursor: pointer;
  margin-right: 20px;
  margin-bottom: 20px;
  height: 389px;
}
.ops-ctn {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}
.categories-tree {
  position: absolute;
  background: white;
  bottom: 0;
  left: 0;
  width: 100%;
  transform: translate(0, 100%);
  border: 1px solid @border3Color;
  border-radius: 10px;
  z-index: 1;
  overflow-x: hidden;
}
</style>
